"use client";
import {
  FormControlLabel,
  RadioGroup,
  RadioGroupProps,
  Radio as MuiRadio,
  RadioProps as MuiRadioProps,
  FormControl,
  FormControlProps,
  FormHelperText,
  FormHelperTextProps,
  SxProps,
  Theme,
} from "@mui/material";

interface RadioProps<T, Option> {
  options: Option[];
  value: T;
  helperText?: string;
  onChange: (option: Option) => void;
  getOptionLabel: (o: Option) => string;
  isOptionEqualToValue: (o: Option, v?: T) => boolean;
  FormControlProps?: FormControlProps;
  RadioGroupProps?: Omit<RadioGroupProps, "value" | "onChange">;
  MuiRadioProps?: MuiRadioProps;
  FormHelperTextProps?: FormHelperTextProps;
  sx?: SxProps<Theme>;
}

export function Radio<T, Option>(props: RadioProps<T, Option>) {
  const optionIndex = props.options.findIndex((e) =>
    props.isOptionEqualToValue(e, props.value),
  );

  return (
    <FormControl {...props.FormControlProps}>
      <RadioGroup
        value={optionIndex == -1 ? "" : optionIndex}
        onChange={(e) => {
          props.onChange(props.options[parseInt(e.target.value)]);
        }}
        sx={{
          margin: 1,
          ...props.sx,
        }}
        {...props.RadioGroupProps}
      >
        {props.options.map((option, index) => (
          <FormControlLabel
            key={index}
            value={index}
            control={<MuiRadio {...props.MuiRadioProps} />}
            label={props.getOptionLabel(option)}
            sx={{
              marginLeft: 0,
            }}
          />
        ))}
        {props.helperText ? (
          <FormHelperText>{props.helperText}</FormHelperText>
        ) : undefined}
      </RadioGroup>
    </FormControl>
  );
}
